'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (TeamLogoTypes) {
  TeamLogoTypes["CAP"] = "cap";
  TeamLogoTypes["PRIMARY"] = "primary";
  TeamLogoTypes["WORDMARK"] = "wordmark";
  TeamLogoTypes["TEAM"] = "team";
})(exports.TeamLogoTypes || (exports.TeamLogoTypes = {}));
